<template>

  <div class="mt-4">
    <div class="row mb-4">
      <div class="col-md-9">
        <b-card class="mb-4 shadow-sm">
          <div class="d-flex mb-0 align-items-center justify-content-end">
            <help-icon class="mr-2" size="18"/>
            <span>{{ $t('info.none.tva') }}</span>
          </div>

          <b-form v-unsave-detector @submit.stop.prevent="onSubmit">

            <div v-for="typeFrais in typesFrais" class="mb-4">

              <div class="row">
                <div class="col-md-12">
                  <span class="section-title">{{ $t(typeFrais.text) }}</span>
                </div>
              </div>

              <template v-for="simulationCharge in simulationCharges">
                <simulation-charge-component
                  v-if="simulationCharge.typeFrais.value === typeFrais.value"
                  :simulation-charge="simulationCharge"
                  @didChangeValue="emitChangeValue"
                  @removedSimulationCharge="removedSimulationCharge"/>
              </template>

              <div class="row mt-2 mb-4">
                <div class="col-md-12">
                  <span class="bold-text addLink"
                        @click="addSimulationCharge(typeFrais)"> + {{ $t('Add') }} {{ $t(typeFrais.text) }}</span>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col-md-12">
                <span class="section-title">{{ $t("bank.loan") }}</span>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-md-3">
                <b-form-group
                  :label="$t('bank.loan.amount')"
                  class="medium-label mb-4"
                  label-for="amount-input">
                  <b-input-group>
                    <b-form-input
                      id="amount-input"
                      v-model="bankCredit.amount"
                      v-disable-scroll
                      min="0"
                      required
                      step="any"
                      type="number"
                      @input="calculateInterest">
                    </b-form-input>
                    <b-input-group-append>
                      €
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group
                  :label="$t('bank.loan.interest.rate')"
                  class="medium-label mb-4"
                  label-for="interest-input">
                  <b-input-group>
                    <b-form-input
                      id="interest-input"
                      v-model="bankCredit.interest"
                      v-disable-scroll
                      min="0"
                      required
                      step="0.01"
                      type="number"
                      @input="calculateInterest"
                    />
                    <b-input-group-append>
                      %
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group
                  :label="$t('bank.loan.durations')+' '+$t('bank.loan.inMonth')"
                  class="medium-label mb-4"
                  label-for="duration-input">
                  <b-form-input
                    id="duration-input"
                    v-model="bankCredit.duration"
                    v-disable-scroll
                    min="0"
                    required
                    step="1"
                    type="number"
                    @input="calculateInterest"/>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group
                  :label="$t('society.balance.sheet.total.versement.investor')"
                  class="medium-label mb-4"
                  label-for="interestAmount-input">
                  <b-input-group>
                    <b-form-input
                      id="interestAmount-input"
                      v-model="this.interestAmount"
                      v-disable-scroll
                      disabled
                      min="0"
                      step="any"
                      type="number">
                    </b-form-input>
                    <b-input-group-append>
                      €
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>

            <div class="d-flex justify-content-end">
              <b-button class="mr-3" variant="outline-primary" @click="back">{{ $t('Back') }}</b-button>
              <b-button type="submit" variant="primary">{{ $t('simulation.Simulate') }}</b-button>
            </div>
          </b-form>
        </b-card>
      </div>

      <div class="col-md-3">
        <SimulationBilanCardPrice
          :prices="totalPrices">
        </SimulationBilanCardPrice>
      </div>
    </div>

    <add-simulation-charge-modal
      :type-frais="selected.typeFrais"
      @didAddSimulationCharge="didAddSimulationCharge"/>

  </div>

</template>

<script>

import api from '../../../services/api'
import AddSimulationChargeModal from "../components/AddSimulationChargeModal";
import SimulationChargeComponent from "../components/SimulationChargeComponent";
import SimulationBilanCardPrice from "./components/SimulationBilanCardPrice.vue";

export default {

  name: "SimulationInsurances",

  components: {
    SimulationBilanCardPrice,
    SimulationChargeComponent,
    AddSimulationChargeModal
  },

  props: {
    simulationId: {
      type: Number,
      default: null
    },
    bankCredit: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      simulationCharges: [],
      simulationChargesIdsToRemove: [],
      typesFrais: [],
      interestAmount: 0,
      selected: {
        typeFrais: null
      },
      totalPrices: []
    }
  },

  emits: ['didContinueInsurances', 'didBack', 'didChangeValue'],

  mounted() {
    this.fetchData()
    this.calculateInterest()
  },

  methods: {

    async fetchData() {
      await this.getTypesFrais()
      await this.getSimulationCharges()
      await this.getTotalOfBilan()
    },

    async getTypesFrais() {
      await api
        .get(`/simulationCharge/getTypesFrais`)
        .then(response => {
          this.typesFrais = response.data
        })
    },

    async getSimulationCharges() {
      if (this.simulationId != null) {
        await api
          .get(`/simulationCharge/getAllForSimulation/${this.simulationId}`)
          .then(response => {
            this.simulationCharges = response.data
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'SimulationIndex',
                params: {
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    async getTotalOfBilan() {
      await api
        .get(`/simulation/getTotalOfBilan/${this.simulationId}`)
        .then(response => {
          this.totalPrices = response.data
          if (this.bankCredit.amount <= 0) {
            this.bankCredit.amount = this.totalPrices[0].prixTTC + this.totalPrices[1].prixTTC + this.totalPrices[2].prixTTC
          }
        })
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },

    addSimulationCharge(typeFrais) {
      this.selected.typeFrais = typeFrais
      this.$bvModal.show('add-simulation-charge-modal')
    },

    didAddSimulationCharge(simulationCharge) {
      this.selected.typeFrais = null
      this.simulationCharges.push(simulationCharge)
    },

    removedSimulationCharge(simulationCharge) {
      if (simulationCharge.id) {
        this.simulationChargesIdsToRemove.push(simulationCharge.id)
      }
      this.simulationCharges.splice(this.simulationCharges.indexOf(simulationCharge), 1)
    },

    back() {
      this.$confirm(this.$i18n.t('Back.confirm').toString()).then(() => {
        this.$emit('didBack')
      });
    },

    async onSubmit() {
      await this.createOrUpdateSimulationCharges()
      await this.deleteSimulationCharges()
      await this.editSimulation()
      this.$emit('didContinueInsurances')
    },

    calculateInterest() {
      this.interestAmount = ((Number(this.bankCredit.interest) * Number(this.bankCredit.amount) / 100) / 12) * Number(this.bankCredit.duration)
    },

    async createOrUpdateSimulationCharges() {
      for (const simulationCharge of this.simulationCharges) {
        let data = new FormData()
        data.append('simulationId', this.simulationId)
        data.append('name', simulationCharge.name)
        data.append('prixTTC', simulationCharge.prixTTC)
        data.append('typeFrais', simulationCharge.typeFrais.value)

        let url = 'simulationCharge'
        if (simulationCharge.id) {
          url = '/simulationCharge/' + simulationCharge.id
        }

        await api({
          method: 'POST',
          url: url,
          data: data
        })
          .then(() => {
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'SimulationIndex',
                params: {
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    async deleteSimulationCharges() {
      for (const simulationChargeId of this.simulationChargesIdsToRemove) {
        await api
          .delete(`/simulationCharge/${simulationChargeId}`)
      }
    },

    async editSimulation() {

      let data = new FormData()
      data.append('insurancesCreationDone', true)
      data.append('amount', this.bankCredit.amount)
      data.append('duration', this.bankCredit.duration)
      data.append('interest', this.bankCredit.interest)

      api({
        method: 'POST',
        url: '/simulation/' + this.simulationId,
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    }

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/simulation/createEditSteps/SimulationInsurances.vue